import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import PriceFormat from "react-number-format";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Fab from '@material-ui/core/Fab'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Tooltip from '@material-ui/core/Tooltip'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import IconButton from '@material-ui/core/IconButton'
import Alert from "@material-ui/lab/Alert"
import blue from '@material-ui/core/colors/blue'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'

import CartDetails from "./CartDetails";

import {_t} from '../../../i18n/lang'
import AjaxLoading from "../../AjaxLoading"
import CartFeatures from "./CartFeatures"
import { projectFeaturesConstants } from "../../../constants/projectFeaturesConstants"


const useStyles = makeStyles((theme) => ({
    fabStyle: {
        marginRight: '1em',
        backgroundColor: '#cb0101'
    },
    headerColor: {
        color: '#cb0101',
    },
    alertWrap: {
        marginTop: '20px',
    }
}));

const Cart = (props) => {
    const {
        cart,
        removeProjectFromCart,
        isLoading,
        addProjectDetails,
        editProjectDetailQty,
        removeDetailFromProject,
        editProjectDetailVendorIdentifier,
        eurExchangeRate,
        loadCart2AB,
        editProjectFeature,
    } = props

    const classes = useStyles();

    const displayItems = [];

    if (cart && cart.size) {
        cart.forEach((value) => {
            displayItems.push(value)
        })
    }

    const priceInPln = (originalPrice, currency) => {
        if (currency === 'EUR') {
            return originalPrice * eurExchangeRate
        }

        return originalPrice
    }

    const valueOf = () => {
        let displayCurrency = 'PLN'
        let totalValue = 0
        displayItems.forEach((item) => {
            item.details.forEach((detail) => {
                let finalPrice = priceInPln(detail.price, detail.currency)
                totalValue += parseFloat(finalPrice) * parseInt(detail.qty, 10)
            })
        })
        return (
            <>
                <PriceFormat
                    decimalSeparator='.'
                    thousandSeparator=' '
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={totalValue}
                    displayType={'text'}
                />{` ${displayCurrency}`}
            </>
        )
    }

    const validate = () => {
        let endCustomerShipmentInCart = false
        let moreThenOneProject = false
        displayItems.forEach((item, key) => {
            if (key > 0) {
                moreThenOneProject = true;
            }

            if (!item.features) {
                return
            }

            const shipmentFeature = item.features.filter(
                feature => feature.featureName === projectFeaturesConstants.END_CUSTOMER_SHIPMENT
            )

            if (shipmentFeature.length) {
                endCustomerShipmentInCart = true
            }
        })

        return {
            showEndCustomerShipmentWarning: moreThenOneProject && endCustomerShipmentInCart,
            endCustomerRequired: endCustomerShipmentInCart,
        }
    }

    const validationResult = validate();

    return (
        <div style={{position: "relative"}}>
            <h1 className={classes.headerColor} >
                <Fab aria-label="cart" color="secondary" size="medium" className={classes.fabStyle}>
                    <FontAwesomeIcon icon={faShoppingCart}  />
                </Fab>
                {_t('CART_LIST_HEADER')}
            </h1>

            {validationResult.showEndCustomerShipmentWarning && (
                <div className={classes.alertWrap}>
                    <Alert severity="warning">
                        {_t('PP_CART_END_CUSTOMER_SHIPMENT_WARNING_BODY')}
                    </Alert>
                </div>
            )}

            {isLoading ? (
                <AjaxLoading style={{marginTop: '2em'}}/>
            ) : (
                <>
                    {(displayItems.length) ? (
                        <>
                            <List>
                                {displayItems.map((row) => {
                                    const listKey = `project-key-${row.id}`
                                    return (
                                        <React.Fragment key={listKey}>
                                            <ListItem style={{paddingBottom: 'rgba(0, 0, 0, 0.12)'}}>
                                                <ListItemText>
                                                    <div style={{
                                                        display: 'inline-block',
                                                        width: '100%',
                                                        background: '#efefef'
                                                    }}>
                                                        <div style={{
                                                            float: 'left',
                                                            marginTop: '10px',
                                                            paddingLeft: '5px',
                                                        }}>
                                                            {row.projectNumber} {_t('CART_PROJECT_NO_FOR')} <i>{row.client}</i>
                                                        </div>
                                                        <Tooltip
                                                            style={{
                                                                float: 'right',
                                                                marginRight: '3px'
                                                            }}
                                                            title={_t('CART_LIST_ACTION_REMOVE_TOOLTIP')}
                                                        >
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() => removeProjectFromCart(row)}
                                                            >
                                                                <FontAwesomeIcon
                                                                    size='xs'
                                                                    icon={faTrashAlt}
                                                                    style={{color: blue[500]}}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                    <CartFeatures features={row.features}
                                                                  editProjectFeature={editProjectFeature}
                                                    />
                                                    <CartDetails
                                                        projectId={row.id}
                                                        addProjectDetails={addProjectDetails}
                                                        editProjectDetailQty={editProjectDetailQty}
                                                        removeDetailFromProject={removeDetailFromProject}
                                                        editProjectDetailVendorIdentifier={editProjectDetailVendorIdentifier}
                                                        showVendorIdentifier={String(row.vendor).toLowerCase() === 'canon'}
                                                        priceInPln={priceInPln}
                                                        customDetails={row.details}
                                                    />
                                                </ListItemText>
                                            </ListItem>
                                            <Divider />
                                        </React.Fragment>
                                    )}
                                )}
                                <ListItem >
                                    <ListItemText>
                                        {_t('CART_SUMMARY_AMOUNT')}
                                        <span style={{fontWeight: 'bold', textAlign: 'right', width: '82%', display: 'inline-block'}}>
                                            {valueOf()}
                                        </span>
                                    </ListItemText>
                                </ListItem>
                            </List>
                            <div style={{textAlign: 'right', marginTop: '2em'}}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<FontAwesomeIcon icon={faCartPlus}  size='xs' />}
                                    onClick={() => {
                                        loadCart2AB(cart)
                                    }}
                                    style={{
                                        backgroundColor: '#cb0101',
                                        color: '#fff'
                                    }}
                                >
                                    {_t('CART_LIST_ACTION_LOAD_IN_AB')}
                                </Button>
                            </div>
                        </>
                    ) : (
                        <div key='no-item' style={{textAlign: 'center', margin: '2em 0'}}>
                            {_t('CART_LIST_ITEM_EMPTY')}
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

Cart.propTypes = {
    cart: PropTypes.object,
    removeProjectFromCart: PropTypes.func,
    isLoading: PropTypes.bool,
    addProjectDetails: PropTypes.func,
    editProjectDetailQty: PropTypes.func,
    removeDetailFromProject: PropTypes.func,
    editProjectDetailVendorIdentifier: PropTypes.func,
    eurExchangeRate: PropTypes.number,
    loadCart2AB: PropTypes.func,
    editProjectFeature: PropTypes.func,
}

export default Cart
